import { render, staticRenderFns } from "./MultiplesMessages.vue?vue&type=template&id=72d662f4&scoped=true&"
import script from "./MultiplesMessages.vue?vue&type=script&lang=js&"
export * from "./MultiplesMessages.vue?vue&type=script&lang=js&"
import style0 from "./MultiplesMessages.vue?vue&type=style&index=0&id=72d662f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d662f4",
  null
  
)

export default component.exports